import './style.scss';

export const Banner = () => {

    return <div className="container-banner row">
        <div className='col-12 col-lg-6 d-flex justify-content-center flex-column'>
            <p className='banner-header font-bold fs-heading-max-large'>RAISE</p>
            <p className='banner-header font-bold fs-heading-large-2 text-uppercase'>AirDrop & Online Shop</p>
            <p className='banner-header font-bold fs-heading-large-2 text-uppercase'>Card type ad Collection</p>
            {/* <p className='fs-default font-extra-light'>Smell token Tracking Card & Collection</p> */}
            <p className='fs-label font-regular'>Customer Support : 9:00 AM - 6:00 PM JST (Japan Standard Time)</p>
        </div>
        <div className='col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end banner-image position-relative'>
            <img src='/images/banner-new.png' className='position-absolute card-banner-img' alt="gold card" />
            <div className='elip-bright'></div>
        </div>
    </div>
}